import React, { createContext, useContext, useReducer } from "react";
export const DiagramSettingsContext = createContext();
export const DiagramSettingsProvider = ({ reducer, initialState, children }) => /* @__PURE__ */ React.createElement(DiagramSettingsContext.Provider, { value: useReducer(reducer, initialState) }, children);
export const useDiagramSettingsState = () => useContext(DiagramSettingsContext);
